import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UtilService {

  generarHorarios(horaInicio: number, horaFin: number, intervaloMinutos: number): string[] {
      const horarios: string[] = [];
    
      let minutosTotales = horaInicio * 60;
    
      const finEnMinutos = horaFin * 60;
    
      while (minutosTotales <= finEnMinutos) {
        const horas = Math.floor(minutosTotales / 60);
        const minutos = minutosTotales % 60;
    
        const horaFormateada = `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
        horarios.push(horaFormateada);
    
        minutosTotales += intervaloMinutos;
      }
    
      return horarios;
    }

    titleCase(str: string): string {
      return str
        .toLowerCase()
        .replace(/\b\w/g, (match) => match.toUpperCase());
    }
}
